export default __webpack_public_path__ + "535cb58af82f8225f2bdb06ecae9e3f5.png";